<template>
  <a-space direction="vertical" style="width:100%" size="middle">
    <a-card :bordered="false">
      <a-space>
        <a-button type="primary" @click="openCreate">Добавить ребёнка</a-button>
        <a-button @click="load" :loading="loading">Обновить</a-button>
      </a-space>
    </a-card>

    <a-card title="Дети" :bordered="false">
      <a-table
        :dataSource="children"
        :columns="columns"
        :loading="loading"
        :pagination="false"
        rowKey="id"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'active'">
            <a-switch :checked="!!record.active" @change="toggleActive(record)" />
          </template>

          <template v-else-if="column.key === 'actions'">
            <a-space>
              <a-button size="small" @click="openEdit(record)">Редактировать</a-button>
              <a-button size="small" @click="openTags(record)">Теги</a-button>
            </a-space>
          </template>
        </template>
      </a-table>
    </a-card>

    <a-modal v-model:open="editOpen" :title="editing?.id ? 'Редактирование ребёнка' : 'Новый ребёнок'" @ok="saveChild" :confirmLoading="saving">
      <a-form layout="vertical">
        <a-form-item label="ФИО">
          <a-input v-model:value="form.full_name" />
        </a-form-item>

        <a-form-item label="Комментарий">
          <a-textarea v-model:value="form.comment" :rows="3" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal v-model:open="tagsOpen" title="Теги ребёнка" @ok="saveTags" :confirmLoading="savingTags">
      <a-form layout="vertical">
        <a-form-item label="Ребёнок">
          <a-input :value="tagChild?.full_name" disabled />
        </a-form-item>

        <a-form-item label="Теги">
          <a-select
            v-model:value="selectedTagIds"
            mode="multiple"
            :options="tagOptions"
            style="width:100%"
            placeholder="Выберите теги"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-space>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { getChildren, createChild, updateChild, setChildActive, setChildTags } from '../../api/children'
import { getTags } from '../../api/tags'
import { label } from '../../utils/labels'

const loading = ref(false)
const saving = ref(false)
const savingTags = ref(false)

const children = ref([])
const tags = ref([])

const editOpen = ref(false)
const tagsOpen = ref(false)

const editing = ref(null)
const tagChild = ref(null)

const form = ref({
  full_name: '',
  comment: '',
})

const selectedTagIds = ref([])

const columns = [
  { title: 'ФИО', dataIndex: 'full_name' },
  { title: 'Комментарий', dataIndex: 'comment' },
  { title: 'Активен', key: 'active', width: 100 },
  { title: '', key: 'actions', width: 220 },
]

const tagOptions = computed(() =>
  tags.value
    .filter(x => x.active)
    .map(x => ({
      value: x.id,
      label: `${x.name} (${label(x.kind)})`,
    }))
)

async function load() {
  loading.value = true

  const Children = await getChildren();
  const KitchenTags = await getTags();

  const x = 1;

  try {
    const [childrenRes, tagsRes] = await Promise.all([
      getChildren(),
      getTags(),
    ])
    children.value = childrenRes.data.data || []
    tags.value = tagsRes.data.data || []
    console.log(tags.value)
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка загрузки')
  } finally {
    loading.value = false
  }
}

function openCreate() {
  editing.value = null
  form.value = { full_name: '', comment: '' }
  editOpen.value = true
}

function openEdit(row) {
  editing.value = row
  form.value = {
    full_name: row.full_name || '',
    comment: row.comment || '',
  }
  editOpen.value = true
}

async function saveChild() {
  saving.value = true
  try {
    if (editing.value?.id) {
      await updateChild(editing.value.id, form.value)
    } else {
      await createChild(form.value)
    }
    editOpen.value = false
    message.success('Сохранено')
    await load()
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка сохранения')
  } finally {
    saving.value = false
  }
}

async function toggleActive(row) {
  try {
    await setChildActive(row.id, !row.active)
    message.success('Сохранено')
    await load()
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка изменения активности')
  }
}

function openTags(row) {
  tagChild.value = row
  selectedTagIds.value = (row.tag_ids || []).slice()
  tagsOpen.value = true
}

async function saveTags() {
  if (!tagChild.value?.id) return
  savingTags.value = true
  try {
    await setChildTags(tagChild.value.id, selectedTagIds.value)
    tagsOpen.value = false
    message.success('Теги сохранены')
    await load()
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка сохранения тегов')
  } finally {
    savingTags.value = false
  }
}

onMounted(load)
</script>
